import { Locale } from "../Locale.js";

export const contactId = {
	[Locale.cs]: "kontakt",
	[Locale.en]: "contact",
	[Locale.sk]: "kontakt",
};
